<template>
  <v-layout wrap row>
    <v-flex xs12 my-2 mt-4 style="text-transform:uppercase;font-weight:bold;">
      variants
    </v-flex>
    <v-flex xs12>
      <v-layout wrap row>
        <v-flex xs12 md12 pb-1 v-for="(variant, p) in variants" :key="'price-' + p ">
          <v-layout wrap row>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="SKU"
                outline
                :disabled="variant.id ? true : false"
                hide-details
                v-model="variant.sku"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="Name"
                outline
                hide-details
                v-model="variant.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="Name AR"
                outline
                hide-details
                v-model="variant.name_ar"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="Name EN"
                outline
                hide-details
                v-model="variant.name_en"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-select
                label="Name EN"
                outline
                :items="['size', 'color']"
                hide-details
                v-model="variant.type"
              ></v-select>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-switch label="Active" v-model="variant.active"></v-switch>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-progress-linear v-if="uploadProgress > 0" :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12>
          
          <v-btn color="primary" block @click="newVariant()">add variant</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { firebase, store, db, auth, storageRef } from '@/fb';
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  components: {
    VueEditor
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings', 'resource', 'variants'],
  data(){
    return {
      rules: {
        required: value => !!value || 'required',
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'valid_email'
      },
      datepicker:{},
      timepicker:{},
      menu:{},
      uploadProgress:0,
      file:null,
      name:null,
      uploadURL:null,
    }
  },
  methods: {
    removeVariant(variant) {
      this.$emit('removeVariant', variant )
    },
    newVariant(){
      this.$emit('newVariant', {} )
    },
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${x.name} required`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `Not valid email`, 'error')
        }
      })
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    },

          

    
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>